import React from 'react';
import {FormattedMessage} from 'react-intl';
import {RetailerItemFormModes, RetailerItemImageType, UserLevels} from '../utils';

import * as ResourceApi from 'api/resources';
import {filterOptionsFactory, sortOptionsFactory} from 'viewOptions/factories';


const baseConfig = {
  key: 'retailerItemForm',
  fields: [
    {
      name: 'level',
      type: 'dropdown',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.level' />
          </div>
        ),
        options: Object.keys(UserLevels).map(key => {
          const level = UserLevels[key];
          return {
            textKey: `rewardsStore.userLevel.${level.toLowerCase()}`,
            value: level
          };
        }),
        required: true
      }
    },
    {
      name: 'retailerId',
      type: 'retailerDropdown',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.retailer' />
          </div>
        ),
        required: true
      }
    },
    {
      name: 'points',
      type: 'number',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.points' />
          </div>
        ),
        min: 0,
        required: true,
        validationRules: [
          {
            type: 'IntegerFormat'
          },
          {
            type: 'InclusiveRange',
            params: {
              min: 1,
              max: 100000
            }
          }
        ]
      }
    },
    {
      name: 'price',
      type: 'retailerItemCurrency',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.price' />
          </div>
        ),
        required: true,
        validationRules: [
          {
            type: 'IntegerFormat'
          },
          {
            type: 'InclusiveRange',
            params: {
              min: 1,
              max: 100000
            }
          }
        ]
      }
    },
    {
      name: 'cost',
      type: 'retailerItemCurrency',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.cost' />
          </div>
        ),
        required: true,
        validationRules: [
          {
            type: 'NumberFormat'
          },
          {
            type: 'InclusiveRange',
            params: {
              min: 1,
              max: 100000
            }
          }
        ]
      }
    },
    {
      name: 'title',
      type: 'text',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.title' />
          </div>
        ),
        required: true,
        validationRules: [
          {
            type: "ProperCurrencyValue",
            params: {
              currencyField: "price"
            }
          }
        ]
      }
    },
    {
      name: 'description',
      type: 'contenteditable',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.description' />
          </div>
        ),
        required: true
      }
    },
    {
      name: 'legal',
      type: 'contenteditable',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.legal' />
          </div>
        ),
        required: true
      }
    },
    {
      name: 'imageId',
      idFor: 'image',
      type: 'retailerItemImagePicker',
      props: {
        imageType: RetailerItemImageType,
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.image' />
          </div>
        ),
        required: true
      }
    }
  ]
};

export default {
  [RetailerItemFormModes.Create]: baseConfig,
  [RetailerItemFormModes.Update]: {
    ...baseConfig,

    // users cannot change vendor on existing items.
    fields: baseConfig.fields.filter(field => field.name !== 'retailerId')
  }
};



// WEBPACK FOOTER //
// ./public/pages/Rewards/RetailerItemModal/retailerItemFormConfig.jsx